import { http } from '../../../../api/http';
import type { SerieListItem, SerieRequest } from '../types/serie';

export class SerieService {
  private static readonly BASE = '/pos/series';

  static async getAll(): Promise<SerieListItem[]> {
    const response = await http.get(this.BASE);
    return response.data;
  }

  static async create(data: SerieRequest): Promise<any> {
    const response = await http.post(this.BASE, data);
    return response.data;
  }

  static async update(id: number, data: SerieRequest): Promise<any> {
    const response = await http.put(`${this.BASE}/${id}`, data);
    return response.data;
  }

  static async remove(id: number): Promise<void> {
    await http.delete(`${this.BASE}/${id}`);
  }
}
